"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRouter = void 0;
const router_1 = require("next/router");
const qs_1 = require("qs");
const sitemapGenerator_1 = require("./sitemapGenerator");
function createRouter(routes) {
    return {
        route: (route, params = undefined) => ({
            pathname: routes[route],
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            query: params !== null && params !== void 0 ? params : null,
        }),
        routeToUrl: (route, params = undefined) => {
            let pathname = routes[route];
            if (!pathname) {
                throw new Error(`Route '${String(route)}' not found.`);
            }
            const restParams = {};
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            Object.keys(params !== null && params !== void 0 ? params : {}).forEach((key) => {
                const value = params[key];
                const segment = `[${key}]`;
                const catchAllSegments = `[...${key}]`;
                const catchAllSegmentsOptional = `[[...${key}]]`;
                if (pathname.includes(segment)) {
                    pathname = pathname.replace(segment, value);
                }
                else if (pathname.includes(catchAllSegmentsOptional)) {
                    if ((Array.isArray(value) && value.length === 0) ||
                        value === null ||
                        value === undefined ||
                        value === "") {
                        pathname = pathname.replace(`/${catchAllSegmentsOptional}`, "");
                    }
                    else if (Array.isArray(value)) {
                        // catch all segments optional
                        pathname = pathname.replace(catchAllSegmentsOptional, value.join("/"));
                    }
                    else {
                        pathname = pathname.replace(catchAllSegmentsOptional, value);
                    }
                }
                else if (pathname.includes(catchAllSegments)) {
                    // catch all segments
                    if (Array.isArray(value)) {
                        if (value.length === 0) {
                            throw new Error(`Parameter '${key}' can not be empty array for route '${String(route)}'`);
                        }
                        pathname = pathname.replace(catchAllSegments, value.join("/"));
                    }
                    else {
                        pathname = pathname.replace(catchAllSegments, value);
                    }
                }
                else {
                    restParams[key] = value;
                }
            });
            if (Object.keys(restParams).length > 0) {
                pathname = `${pathname}?${(0, qs_1.stringify)(restParams)}`;
            }
            return pathname;
        },
        useActiveRoute: () => {
            const router = (0, router_1.useRouter)();
            const activeRoute = Object.keys(routes).find((route) => routes[route] === router.pathname);
            if (!activeRoute) {
                throw new Error("Active route not found.");
            }
            return activeRoute;
        },
        createSitemapGenerator: sitemapGenerator_1.createSitemapGenerator,
        routes,
        useQueryParams: () => (0, router_1.useRouter)().query,
    };
}
exports.createRouter = createRouter;
